import {
    REALTIME_UNASSIGNED_BOOKING_NOTIFICATION_SUCCESS
    } from "../types"
    
    const unassignedNotification = {
      loading: false,
      error: false,
      message: null,
      notificationInfo: null,
    }
    
    export default function (state = unassignedNotification, action) {
      switch (action.type) {
        case REALTIME_UNASSIGNED_BOOKING_NOTIFICATION_SUCCESS:
          return {
            ...state,
            loading: false,
            error: false,
            message: null,
            notificationInfo: action.payload
          }
        default:
          return state
      }
    }